import { render, staticRenderFns } from "./PopupLoadPrevBoard.vue?vue&type=template&id=46da4a62&scoped=true"
import script from "./PopupLoadPrevBoard.vue?vue&type=script&lang=js"
export * from "./PopupLoadPrevBoard.vue?vue&type=script&lang=js"
import style0 from "./PopupLoadPrevBoard.vue?vue&type=style&index=0&id=46da4a62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46da4a62",
  null
  
)

export default component.exports